import { lazyCreateOrUpdateOptionsForFeature } from 'owa-outlook-service-options';
import { getOptionsForFeature, OwsOptionsFeatureType } from 'owa-outlook-service-option-store';
import type { ListViewColumnHeadersOptions } from 'owa-outlook-service-option-store';
import {
    onSenderColumnWidthChangedInternalMutator,
    onSubjectColumnWidthChangedInternalMutator,
} from '../mutators/columnWidthMutators';

export function onFirstColumnHandleChanged(
    senderColumnWidth: number,
    subjectColumnWidth: number
): void {
    // Get existing settings on server
    const userOptions = getOptionsForFeature<ListViewColumnHeadersOptions>(
        OwsOptionsFeatureType.ListViewColumnHeaders
    );

    // Update settings on server
    lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.ListViewColumnHeaders,
        {
            ...userOptions,
            senderColumnWidth,
            subjectColumnWidth,
        } as ListViewColumnHeadersOptions
    );

    // Update store
    onSenderColumnWidthChangedInternalMutator(senderColumnWidth);
    onSubjectColumnWidthChangedInternalMutator(subjectColumnWidth);
}
